module.exports = __webpack_public_path__ + "img/组 7474.98bb2832.png";